<template lang="pug">
  .checklist-items(@dragover.prevent @dragenter.prevent)
    CheckListItem.item(
      v-for="(item, i) in items"
      :key="JSON.stringify([item, i])"
      :value="item"
      :editable="editable"
      :changeable="changeable"
      :editing="editableItem === item"
      @change="onItemChange(item, $event)"
      @enter="$emit('enter', $event)"
      @edit="$emit('edit', item)"
      @delete="onItemDelete(item)"
      @copy="onItemCopy(item)"

      :class="{ disabled: !!draggableItem, replacing: draggableItem === item }"
      :draggable="editable"
      @dragstart.native="onDragStart($event, item)"
      @dragenter.native="onDragEnter(item)"
      @dragend.native="onDragEnd"
      @drop.native="onDrop(item)"
    )
</template>

<script>
import CheckListItem from '@/components/checlkist/CheckListItem.vue';

export default {
  name: 'CheckListItems',
  components: { CheckListItem },
  props: {
    items: Array,
    editable: Boolean,
    changeable: Boolean,
    editableItem: Object,
  },
  data() {
    return {
      draggableItem: null,
      prevHoveredItem: null,
    };
  },
  methods: {
    isDraggableItemValid(item) {
      return item?.checked !== undefined && item?.label !== undefined;
    },
    onDragStart(e, item) {
      if (this.editableItem === item) {
        e.preventDefault();
        return;
      }

      e.dataTransfer.effectAllowed = 'move';
      this.draggableItem = item;
    },
    onDragEnter(hoverItem) {
      if (!this.isDraggableItemValid(this.draggableItem)) return;
      if ([this.draggableItem, this.prevHoveredItem].includes(hoverItem)) {
        return;
      }

      this.prevHoveredItem = hoverItem;
      setTimeout(() => { this.prevHoveredItem = null; }, 100);

      const draggableIndex = this.items.findIndex((item) => item === this.draggableItem);
      const hoverIndex = this.items.findIndex((item) => item === hoverItem);

      const items = [...this.items];
      items.splice(draggableIndex, 1);
      items.splice(hoverIndex, 0, this.draggableItem);
      this.$emit('change', { items, save: false });
    },
    onDrop(hoverItem) {
      if (!this.isDraggableItemValid(this.draggableItem)) return;
      const draggableIndex = this.items.findIndex((item) => item === this.draggableItem);
      const hoverIndex = this.items.findIndex((item) => item === hoverItem);

      const items = [...this.items];
      items.splice(draggableIndex, 1);
      items.splice(hoverIndex, 0, this.draggableItem);
      this.$emit('change', { items, save: true });
    },
    onDragEnd() {
      this.draggableItem = null;
      this.prevHoveredItem = null;
    },

    onItemChange(prevItem, newItem) {
      const { items } = this;
      const index = items.indexOf(prevItem);
      items[index] = newItem;
      this.$emit('change', { items, save: true });
    },
    onItemDelete(deletableItem) {
      const items = this.items.filter((item) => item !== deletableItem);
      this.$emit('change', { items, save: true });
    },
    onItemCopy(item) {
      const newItem = { ...item };

      if (item.number) {
        newItem.number = Math.max(0, ...this.items.map(i => i.number)) + 1;
      }

      const items = [...this.items, newItem];
      this.$emit('change', { items, save: true });
      this.$emit('edit', newItem);
    },
  },
};
</script>

<style scoped lang="scss">
  .items {
    display: flex;
    flex-direction: column;
  }

  .item {
    border-bottom: 1px solid #D9DADA;

    &:last-child {
      border: none;
    }

    &.disabled > * {
      pointer-events: none;
    }

    &.replacing {
      opacity: .3;
    }
  }
</style>
